export default __webpack_public_path__ + "media/images/features/jtb/flow-387fa586b5af403ff91340374fd3329c.png";